// Sibling imports
const {
  CONFIGURE_HISTORY,
  GO_BACK,
  GO_FORWARD,
  PUSH,
  RELOAD,
  REPLACE,
  setLocation
} = require('./actions')
const { configureBrowserNavigation } = require('./events')

const routerMiddleware = store => {
  let history
  return next => action => {
    switch (action.type) {

      // History setup

      case CONFIGURE_HISTORY:
        history = action.payload
        // Setup browser to reload for back/forward navigation to this page
        configureBrowserNavigation(store)
        // Keep the history and router location synchronized
        history.listen((location, action) => {
          store.dispatch(setLocation({ location, action }))
        })
        return

      // History actions

      case GO_BACK:
        history.goBack()
        return
      case GO_FORWARD:
        history.goForward()
        return
      case PUSH: {
        const { path, state } = action.payload
        history.push(path, state)
        return
      }
      case REPLACE: {
        const { path, state } = action.payload
        history.replace(path, state)
        return
      }

      // Location actions

      case RELOAD:
        if (typeof window !== 'undefined') {
          window.location.reload(true)
        }
        return

      default:
        next(action)
        return
    }
  }
}

module.exports = routerMiddleware
